import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-bed',
  templateUrl: './icon-bed.component.html',
  styles: []
})
export class IconBedComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
